import { useSelector, useDispatch } from 'react-redux';

import {
  Button,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Text,
} from '@frontend/legacy-components';

import { acceptTerms } from 'modules/auth/login/data/actions';
import { getShowTermsAcceptanceModal } from 'modules/auth/login/data/selectors';

import { getFabricatorTerms, getPrivacyPolicy } from 'store/session/selectors';

const TermsAcceptanceModal = () => {
  const dispatch = useDispatch();
  const fabricatorTerms = useSelector(getFabricatorTerms);
  const privacyPolicy = useSelector(getPrivacyPolicy);
  const isOpen = useSelector(getShowTermsAcceptanceModal);

  const onAccept = () => {
    const acceptedTerms = [];
    if (fabricatorTerms) {
      acceptedTerms.push(fabricatorTerms.id);
    }
    if (privacyPolicy) {
      acceptedTerms.push(privacyPolicy.id);
    }
    dispatch(acceptTerms.request({ acceptedTerms }));
  };

  return (
    <Modal isOpen={isOpen} onClose={() => null}>
      <ModalContent>
        <ModalHeader>Updates to Our Terms and Conditions</ModalHeader>
        <ModalBody>
          <Text>
            Over the last year Paperless Parts has evolved substantially.
            Prompted by this evolution and many discussions with new customers,
            we have decided to update our terms and conditions. We believe these
            terms are very clear on your ownership of your data and the
            confidentiality required of our team. We took these steps to
            reinforce our commitment to supporting the successful growth of your
            business.
          </Text>
          <Text my={1}>
            Please take a moment to review the updated documents:
          </Text>
          {fabricatorTerms && (
            <Text>
              <Link
                color="interaction.main"
                href={fabricatorTerms.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                General Terms
              </Link>
            </Text>
          )}
          {privacyPolicy && (
            <Text>
              <Link
                color="interaction.main"
                href={privacyPolicy.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </Link>
            </Text>
          )}
          <Text my={1}>
            To continue using the Paperless Parts platform, confirm that you
            agree to the updated terms and conditions by clicking I AGREE.
          </Text>
          <Text color="feature.secondary">- The Paperless Parts Team</Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={onAccept} isLoading={false}>
            I AGREE
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TermsAcceptanceModal;
